import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderComponent } from '../header/header.component'; 
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-dashboardcommon',
  templateUrl: './dashboardcommon.component.html',
  styleUrls: ['./dashboardcommon.component.css']
})
export class DashboardcommonComponent implements OnInit {
  openSidebar: boolean = true
  @ViewChild(HeaderComponent) child1: HeaderComponent;
  @ViewChild(SidebarComponent) child2: SidebarComponent;
  constructor() { }

  ngOnInit(): void {
  }

  sidebarToggle() {
this.openSidebar = !this.openSidebar
  }

}
